import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';



export const getDefects = ({ kulModelKodu, garantiTipi}) => {
  return axios.get(`/GetArtemisDefects/${kulModelKodu?.replaceAll('/','')?.replaceAll('.','')}/${garantiTipi}}`);
};

export const getMaterials = ({ kulModelKodu, garantiTipi, hizmetKodu, uyil, udonem,SerialNr }) => {
  const data = getUser();
  return axios.get(`/GetArtemisMaterialsServiceShopSerialTechnician/${kulModelKodu?.replaceAll('/','')?.replaceAll('.','')}/${garantiTipi}/${hizmetKodu}/${uyil}/${udonem}/${data.ServiceShopId}/${SerialNr}/${data.TechnicianId}`);
};

export const getHistoricalMaterials = ({ kulModelKodu, garantiTipi, hizmetKodu, uyil, udonem }) => {
  const data = getUser();
  return axios.get(`/GetArtemisTarihselAgacServiceShop/${kulModelKodu?.replaceAll('/','')?.replaceAll('.','')}/${garantiTipi}/${hizmetKodu}/${uyil}/${udonem}/${data.ServiceShopId}`);
};


export const getLabours = ({ kulModelKodu, garantiTipi, hizmetKodu }) => {
  const data = getUser();
  return axios.get(`/GetArtemisLaboursServiceShop/${kulModelKodu?.replaceAll('/','')?.replaceAll('.','')}/${garantiTipi}/${hizmetKodu}/${data.ServiceShopId}`);
};

